import { CookiesConsentModal } from './cookiesConsentModal';
import { GenericErrorModal } from './genericErrorModal';
import { SessionExpiredModal } from './sessionExpiredModal';

export const AppModals = () => {
	return (
		<>
			<GenericErrorModal />
			<CookiesConsentModal />
			<SessionExpiredModal />
		</>
	);
};
